import styled from '@themes/theme'

export const TimelineMaxH = '55vh'
export const TimelineScoreH = '33px'

// 현재는 사용하지 않는 코드
// 사용하게 된다면 match.style.ts의 TimeLineWrap을 사용해야 함
export const TimeLineWrap = styled.div`
  width: auto;
  max-height: 55vh;
  overflow-x: hidden;
  overflow-y: auto;
  svg {
    width: 12px;
    height: auto;
    transform: translate3d(0, 0, 0);
  }
  .red-card {
    width: auto;
    height: 14px;
    .card {
      fill: ${props => props.theme.color.red};
    }
  }
  .blackout {
    opacity: 0;
  }
  .timeline {
    &--basic, &--line {
      //overflow: auto;
      .top-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 30px;
        padding: 0 18px;
        .team-info {
          li {
            display: inline-flex;
            align-items: center;
            margin-right: 10px;
            &:last-of-type {
              margin-right: 0;
            }
          }
          svg {
            margin-right: 2px;
          }
        }
      }
      .match-contents {
        svg {
          transform: translate3d(0, 2px, 0);
        }
        .match-time {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 24px;
          color: ${props => props.theme.color.modalTxt};
          font-weight: ${props => props.theme.fontW.medium};
          background: ${props => props.theme.color.modalBg};
          .score {
            margin: 0 4px;
            .center {
              margin: 0 4px;
            }
            .win {
              color: ${props => props.theme.color.modalred};
            }
          }
        }
        .match-history {
          display: flex;
          flex-flow: column-reverse;
          margin: 12px 0;
          padding-top: 14px;
          overflow: hidden;
          &::after {
            content: '';
            display:block;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 4px;
            height: 4px;
            background: ${props => props.theme.color.modalSubBg2};
            border-radius: 50%;
          }
          &--item {
            position: relative;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            padding: 6px;
            svg {
              margin: 3px 6px 0;
            }
            .time {
              display: inline-flex;
              justify-content: center;
              align-items: center;
              min-width: 24px;
              height: 24px;
              line-height: 2.4rem;
              padding: 0 4px;
              font-size: ${props => props.theme.font.small};
              color: ${props => props.theme.color.modalTxt};
              border-radius: 12px;
              background: ${props => props.theme.color.themeTxt};
              border: 1px solid ${props => props.theme.color.modalSubBg2};
              &.icehockey {
                width: 41px;
              }
            }
            .player {
              flex: 1;
              margin-top: 3px;
              font-size: ${props => props.theme.font.small};
              font-weight: ${props => props.theme.fontW.medium};
              .score-value {
                margin-left: 4px;
                font-size: ${props => props.theme.font.small};
                font-weight: ${props => props.theme.fontW.medium};
                color: ${props => props.theme.color.modalyellow};
              }
              .assist-player {
                display: flex;
                margin-top: -2px;
                font-size: ${props => props.theme.font.small};
                font-weight: ${props => props.theme.fontW.medium};
                color: ${props => props.theme.color.gray};
              }
            }
          }
        }
      }
    }
    &--basic {
      .match-contents {
        .match-history {
          position: relative;
          &--item {
            z-index: 1;
            &::before {
              content: '';
              display:block;
              z-index: -1;
              position: absolute;
              bottom: 70%;
              left: 50%;
              transform: translateX(-50%);
              width: 1px;
              height: 100%;
              background: ${props => props.theme.color.modalSubBg2};
            }
            &.home-team {
              flex-flow: row-reverse;
              padding-right: calc(50% - 20px);
              .time {
                margin-left: 1px;
              }
              .player, .assist-player {
                justify-content: flex-end;
                text-align: right;
              }
            }
            &.away-team {
              justify-content: flex-end;
              padding-left: calc(50% - 20px);
            }
          }
        }
      }
      &.soccer {
        .match-contents {
          .match-history {
            &--item {
              &.home-team {
                padding-right: calc(50% - 12px);
              }
              &.away-team {
                padding-left: calc(50% - 12px);
              }
            }
          }
        }
      }
    }
    &--line {
      .match-contents {
        .match-history {
          position: relative;
          &::after {
            left: 35px;
          }
          &::before {
            content:'';
            display: block;
            position: absolute;
            bottom: 20px;
            left: 35px;
            width: 1px;
            height: 100%;
            border-left: 1px solid ${props => props.theme.color.modalBg};
          }
          &--item {
            padding: 10px 6px 10px 18px;
            .time {
              width: 38px;
              text-align: right;
            }
            .current-score {
              display: inline-flex;
              justify-content: center;
              align-items: center;
              width: auto;
              min-width: 36px;
              height: 22px;
              margin: 0 6px;
              color: ${props => props.theme.color.modalTxt};
              font-size: ${props => props.theme.font.small};
            }
            .team-emblem {
              display: none;
              width: 100%;
              max-width: 18px;
              height: auto;
              max-height: 18px;
              margin: 2px 4px 0 0;
            }
            &.home-team {
              .home-emblem {
                display:block;
              }
            }
            &.away-team {
              .away-emblem {
                display: block;
              }
            }
          }
        }
      }
    }
    &--line {
      .match-contents {
        .match-history {
          position: relative;
          &::after {
            left: 35px;
          }
          &::before {
            content:'';
            display: block;
            position: absolute;
            bottom: 20px;
            left: 35px;
            width: 1px;
            height: 100%;
            border-left: 1px solid ${props => props.theme.color.modalBg};
          }
          &--item {
            padding: 10px 6px 10px 18px;
            .time {
              width: 38px;
              text-align: right;
            }
            .current-score {
              display: inline-flex;
              justify-content: center;
              align-items: center;
              width: auto;
              min-width: 36px;
              height: 22px;
              margin: 0 6px;
              color: ${props => props.theme.color.modalTxt};
              font-size: ${props => props.theme.font.small};
            }
            .team-emblem {
              display: none;
              width: 100%;
              max-width: 18px;
              height: auto;
              max-height: 18px;
              margin: 2px 4px 0 0;
            }
            &.home-team {
              .home-emblem {
                display:block;
              }
            }
            &.away-team {
              .away-emblem {
                display: block;
              }
            }
          }
        }
      }
    }
    &--table {
      overflow: auto;
      .table {
        width: auto;
        max-width: 100%;
        &--head {
           border-top: 1px solid ${props => props.theme.color.modalBg};
          border-bottom: 1px solid ${props => props.theme.color.modalBg};
          position: relative;
          .round {
            padding: 0 4px;
            text-align: center;
            font-weight: ${props => props.theme.fontW.medium};
            &.total {
              font-weight: ${props => props.theme.fontW.bold};
            }
            &.overtime {
              min-width: 32px;
            }
          }
        }
        &--body {
          .team-name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 74px;
            padding-right: 10px;
            font-weight: ${props => props.theme.fontW.medium};
          }
          .score {
            width: auto;
            min-width: 22px;
            text-align: center;
            font-weight: ${props => props.theme.fontW.medium};
            &.total {
              font-weight: ${props => props.theme.fontW.bold};
              border-right: 1px solid ${props => props.theme.color.modalBg};
              border-left: 1px solid ${props => props.theme.color.modalBg};
            }
            &.win {
              color: ${props => props.theme.color.red};
            }
          }
        }
        &.volleyball {
          .table--head {
            .round {
              min-width: 38px;
            }
          }
        }
      }
    }
  }
`
export const TimelineScoreWrap = styled.div`
  z-index: 2;
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-width: 328px;
  height: ${TimelineScoreH};
  padding: 0 21px;
  background: ${props => props.theme.color.themeTxt};
  border-bottom: 1px solid ${props => props.theme.color.modalBg};
  .team-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc((100% - 61px) / 2);
    .team-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: calc(100% - 28px);
      transform: translateY(3%);
    }
    .team-score {
      width: auto;
      min-width: 21px;
      font-size: ${props => props.theme.font.large};
      &.win {
        color: ${props => props.theme.color.red};
      }
    }
    &.home-team {
      .team-score {
        text-align: right;
      }
    }
    &.away-team {
      .team-score {
        text-align: left;
      }
    }
  }
  .vs {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 37px;
    height: 17px;
    margin: 0 12px;
    border-radius: 9px;
    color: ${props => props.theme.color.themeTxt};
    font-weight: ${props => props.theme.fontW.medium};
    background: ${props => props.theme.color.subBg};
  }

`
